import { useContext } from 'react';
import { Button } from 'primereact/button';
import { useNavigate } from 'react-router';
import { LayoutContext } from '@/layout/context/context';
import { cn } from '@/helpers/utils/functionality-utils';

const AccessDeniedPage = ({ className }: { className?: string }) => {
  const { theme } = useContext(LayoutContext);

  const nav = useNavigate();

  return (
    <div
      className={cn(
        'flex min-h-screen min-w-[100vw] items-center justify-center overflow-hidden bg-surface-50',
        className,
      )}
    >
      <div className="flex flex-col items-center justify-center">
        <img
          src={`/assets/images/logo/logo-${
            theme === 'light' ? 'dark' : 'light'
          }-512.png`}
          alt="Sakai logo"
          style={{ height: '200px', width: '200px' }}
          className="mb-8 shrink-0"
        />
        <div
          style={{
            borderRadius: '56px',
            padding: '0.3rem',
            background:
              'linear-gradient(180deg, rgba(247, 149, 48, 0.4) 10%, rgba(247, 149, 48, 0) 30%)',
          }}
        >
          <div
            className="smpx-8 flex w-full flex-col items-center bg-surface-0 px-8 py-8"
            style={{ borderRadius: '53px' }}
          >
            <div
              className="flex items-center justify-center rounded-full bg-pink-500"
              style={{ height: '3.2rem', width: '3.2rem' }}
            >
              <i className="pi pi-fw pi-exclamation-circle text-2xl text-white"></i>
            </div>
            <h1 className="mb-2 text-5xl font-bold text-surface-900">
              Access Denied
            </h1>
            <div className="mb-8 text-surface-600">
              You do not have the necessary permissions.
            </div>
            <Button
              icon="pi pi-arrow-left"
              label="Go to Dashboard"
              text
              onClick={() =>
                nav('/main/dashboard', {
                  viewTransition: true,
                })
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccessDeniedPage;
